export const SUBMIT_PRODUCT_CATEGORY_TR_FORM = 'productTRForm/SUBMIT_PRODUCT_CATEGORY_TR_FORM';
